<!--
     ExplorerDirectoryPathEditable shows a single path and allows modifications

     USAGE:
     <ExplorerDirectoryPath
       :path="activeDirectory.path"
       :centro_id=""
       @edit="my_custom_onedit"
     ></ExplorerDirectoryPath>
-->

<template>
  <span>
    <span
      v-for="(dir, index) in local_path"
      :key="dir.id"
      ref="owo"
    >
      <span v-if="index > 0"> &gt; </span>

      <!-- Directory selectors -->
      <ExplorerDirectorySelect
        :dirs="neighbor_dirs(dir)"
        :selected="dir.id"
        :index="index"
        @change="update_select"
        clearable
        :props="props"
      />
    </span>

    <!-- Bonus directory selector to allow picking the next subdirectory -->
    <span v-if="bonus_dirs.length > 0">
      <span> &gt; </span>
      <ExplorerDirectorySelect
        :dirs="bonus_dirs"
        :selected="null"
        :index="local_path.length"
        clearable
        @change="update_select"
        :props="props"
      />
    </span>
  </span>
</template>


<script>
 import { mapState } from 'vuex'
 import ExplorerDirectorySelect from '@/components/explorer/ExplorerDirectorySelect'

 export default {
   name: 'ExplorerDirectoryPathEditable',

   props: [
     'path',
     'props',
     'centro_id',
   ],

   components: {
     ExplorerDirectorySelect,
   },

   data: () => ({
     local_path: [],
   }),

   computed: {
     ...mapState([
       'qdirectory',
       'qdirectory_centro_list',
     ]),

     bonus_dirs() {
       // Returns [{dir}, {dir2}, {dir3}] if subdirectories available, else []
       if (this.local_path.length <= 0)
         return [];
       return this.local_path.at(-1).children || [];
     },

     qdirectory_list() {
       return this.qdirectory_centro_list[this.centro_id];
     },
   },

   mounted() {
     this.local_path = this.pathify_with_objects(this.path);
   },

   methods: {
     pathify_with_objects(path) {
       return (path || []).map(d => (d.id === undefined) ? this.qdirectory[d] : d)
     },

     neighbor_dirs(dir) {
       // Input: {dir}
       // Returns: [{neighbor1}, {neighbor2}, {dir}, {neighbor3}]
       if (!dir.parent_id) // root
         return this.qdirectory_list;
       return this.qdirectory[dir.parent_id].children;
     },

     update_select(dir_id, index) {
       // Update local_path to select dir_id
       // If dir_id is null, it will cut local_path untill index
       //  if (dir_id === null)
       if (!dir_id) {
         this.local_path = this.local_path.slice(0, index);
       } else {
         this.local_path = this.pathify_with_objects(this.qdirectory[dir_id].path);
       }
       this.$emit('edit', (this.local_path.at(-1) || {}).id || null);
     },
   },

   watch: {
     path(p) {
       if (p.length <= 0) {
         this.local_path = [{}];
       } else {
         this.local_path = this.pathify_with_objects(p);
       }
     },
   },
 }
</script>


<style lang="scss">
 @import "@/sass/explorer.scss";
</style>
